import Grid from '@mui/material/Grid'
import React from 'react'
import CustomersTable from './customersTable'

const Therapists = () => {
    return (
        <Grid>
            <CustomersTable />
        </Grid>
    )
}

export default React.memo(Therapists)
